import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

export default function Admin() {
  const { user, token, logout } = useAuth();
  const nav = useNavigate();
  const [users, setUsers] = useState([]);
  const [properties, setProperties] = useState([]);
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('stats');

  useEffect(() => {
    if (!user || user.role !== 'admin') {
      nav('/');
      return;
    }

    const fetchDashboard = async () => {
      try {
        const [usersRes, propertiesRes, paymentsRes] = await Promise.all([
          axios.get('/api/admin/users', { headers: { Authorization: `Bearer ${token}` } }),
          axios.get('/api/admin/properties', { headers: { Authorization: `Bearer ${token}` } }),
          axios.get('/api/admin/payments', { headers: { Authorization: `Bearer ${token}` } }),
        ]);
        setUsers(usersRes.data.users || []);
        setProperties(propertiesRes.data.properties || []);
        setPayments(paymentsRes.data.payments || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchDashboard();
  }, [user, token, nav]);

  if (loading) return <div style={{ padding: '2rem', fontFamily: 'Sora' }}>Se incarca...</div>;

  const stats = [
    { title: 'Utilizatori', value: users.length, color: '#006d77' },
    { title: 'Clienti', value: users.filter(u => u.role === 'guest').length, color: '#006d77' },
    { title: 'Gazde', value: users.filter(u => u.role === 'host').length, color: '#006d77' },
    { title: 'Proprietati', value: properties.length, color: '#dd4124' },
    { title: 'Plati', value: payments.length, color: '#dd4124' },
    { title: 'Venituri', value: `${payments.reduce((sum, p) => sum + p.amount, 0)} €`, color: '#dd4124' },
  ];

  return (
    <div style={{
      padding: '0.5rem',
      fontFamily: 'Sora, sans-serif',
      color: '#000',
      maxWidth: '1400px',
      margin: '0 auto'
    }}>
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '1rem',
        flexWrap: 'wrap',
        gap: '0.5rem'
      }}>
        <h1 style={{
          fontFamily: 'Orbitron, sans-serif',
          fontSize: '1.5rem',
          margin: 0,
          color: '#006d77'
        }}>Admin Dashboard</h1>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <button
            onClick={() => nav('/')}
            style={{
              padding: '0.4rem 0.8rem',
              background: 'transparent',
              border: '1px solid #dd4124',
              color: '#dd4124',
              fontFamily: 'Sora',
              fontSize: '0.9rem',
              cursor: 'pointer'
            }}
          >← Home</button>
          <button
            onClick={() => { logout(); nav('/'); }}
            style={{
              padding: '0.4rem 0.8rem',
              background: '#dd4124',
              border: 'none',
              color: '#fff',
              fontFamily: 'Sora',
              fontSize: '0.9rem',
              cursor: 'pointer'
            }}
          >Logout</button>
        </div>
      </div>

      <div style={{
        display: 'flex',
        borderBottom: '1px solid #ccc',
        marginBottom: '1rem',
        flexWrap: 'wrap'
      }}>
        {['stats', 'users', 'properties', 'payments'].map(tab => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            style={{
              padding: '0.5rem 1rem',
              background: 'transparent',
              border: 'none',
              borderBottom: activeTab === tab ? `2px solid ${tab === 'stats' || tab === 'users' ? '#006d77' : '#dd4124'}` : 'none',
              color: activeTab === tab ? '#000' : '#666',
              fontFamily: activeTab === tab ? 'Orbitron' : 'Sora',
              fontSize: '0.9rem',
              cursor: 'pointer',
              textTransform: 'capitalize'
            }}
          >{tab === 'stats' ? 'Statistici' : tab === 'users' ? 'Utilizatori' : tab === 'properties' ? 'Proprietati' : 'Plati'}</button>
        ))}
      </div>

      {activeTab === 'stats' && (
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
          gap: '0.5rem',
          marginBottom: '1rem'
        }}>
          {stats.map((s, idx) => (
            <div key={idx} style={{
              padding: '0.75rem',
              border: `1px solid ${s.color}`,
              textAlign: 'center'
            }}>
              <div style={{
                fontSize: '1.5rem',
                fontFamily: 'Orbitron',
                color: s.color,
                marginBottom: '0.25rem'
              }}>{s.value}</div>
              <div style={{ fontSize: '0.85rem' }}>{s.title}</div>
            </div>
          ))}
        </div>
      )}

      {activeTab === 'users' && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #006d77' }}>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Nume</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Email</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Rol</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {users.map(u => (
                <tr key={u._id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '0.5rem' }}>{u.name}</td>
                  <td style={{ padding: '0.5rem' }}>{u.email}</td>
                  <td style={{ padding: '0.5rem' }}>{u.role}</td>
                  <td style={{ padding: '0.5rem' }}>{u.active ? 'Activ' : 'Inactiv'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'properties' && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #dd4124' }}>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Titlu</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Gazda</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Status</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Pret</th>
              </tr>
            </thead>
            <tbody>
              {properties.map(p => (
                <tr key={p._id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '0.5rem' }}>{p.title}</td>
                  <td style={{ padding: '0.5rem' }}>{p.hostName}</td>
                  <td style={{ padding: '0.5rem' }}>{p.active ? 'Disponibila' : 'Ocupata'}</td>
                  <td style={{ padding: '0.5rem' }}>{p.price} €</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {activeTab === 'payments' && (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #dd4124' }}>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Utilizator</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Suma</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Data</th>
                <th style={{ textAlign: 'left', padding: '0.5rem', fontFamily: 'Orbitron' }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {payments.map(p => (
                <tr key={p._id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '0.5rem' }}>{p.userName}</td>
                  <td style={{ padding: '0.5rem' }}>{p.amount} €</td>
                  <td style={{ padding: '0.5rem' }}>{new Date(p.date).toLocaleDateString()}</td>
                  <td style={{ padding: '0.5rem' }}>{p.status}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}